/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck comment

import { EMAIL_VALIDATION_PATTERN } from "./constants";

export const validateSeveral = (v, functionsArray) => {
  return functionsArray.reduce((value, func) => {
    if (value === false) return false;
    return func(v);
  }, true);
};

export const replaceForPhoneNumber = (value) => {
  return value.replace(/(?!^\+)[^0-9]/g, "");
};

export const getErrorTextWithMultipleValidateFunc = (v, { func, errText }) => {
  if (func && func(v) === false) {
    return errText;
  }

  return "";
};

export const validateEmail = (emailValue) => {
  if (!(typeof emailValue === "string")) return false;
  return EMAIL_VALIDATION_PATTERN.test(emailValue);
};

export const confirmEmailValidate = (confirmEmail, primaryEmail) => {
  return confirmEmail === primaryEmail;
};
